// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-1d3594d0] {\n    margin-top: 1em !important;\n    margin-bottom: 1em !important;\n}\n.table-filter[data-v-1d3594d0] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n            justify-content: flex-end !important;\n}\n.ui.selection.dropdown[data-v-1d3594d0] {\n    margin-right: 5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
